import * as types from '../actionTypes/index';


const productSearchList = (state = null, { type, payload }) => {
	switch (type) {
		case types.PRODUCT_SEARCH_LIST:
			return payload;
		default:
			return state;
	}
};
export default {
	productSearchList
};
